var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{style:(_vm.cssProps)},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }